import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function LessIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3 12C3 11.5 3.5 11 4 11H20C20.5 11 21 11.5 21 12C21 12.5 20.5 13 20 13H4C3.5 13 3 12.5 3 12Z"
				fill="currentColor"
			/>
		</svg>
	);
}

LessIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default LessIcon;
